export type HobbyValues =
  | 'BOARD_GAME'
  | 'BOOK'
  | 'CINEMA'
  | 'COFFEE'
  | 'COMPUTER'
  | 'MUSEUM'
  | 'NATURE'
  | 'SPORT';

export const hobbies: HobbyValues[] = [
  'BOARD_GAME',
  'BOOK',
  'CINEMA',
  'COFFEE',
  'COMPUTER',
  'MUSEUM',
  'NATURE',
  'SPORT',
];

enum HOBBIES {
  BOARD_GAME = 'Jeu de société',
  BOOK = 'Un bon livre',
  CINEMA = 'Cinéma',
  COFFEE = 'Café entre amis',
  COMPUTER = 'Ordinateur',
  MUSEUM = 'Musée',
  NATURE = 'Balade et nature',
  SPORT = 'Sport',
}
export default HOBBIES;
